export const ChevronUpIcon = (props) => {
  return (
    <svg
      width="16"
      height="8"
      viewBox="0 0 16 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M15.8206 7.75321C15.5354 8.06719 15.0753 8.06106 14.7919 7.80713L8.00357 1.70789L1.21429 7.80767C0.91443 8.0744 0.455323 8.05098 0.185662 7.75375C-0.0817261 7.45367 -0.0576248 6.99528 0.240685 6.7275L7.47562 0.192019C7.75415 -0.0561937 8.17183 -0.0561937 8.45058 0.192019L15.6855 6.7275C16.0661 6.99528 16.0889 7.45367 15.8206 7.75321Z"
        fill="#525B7A"
      />
    </svg>
  );
};



